export const parseCommaSeparatedValues = (value: string | null | undefined): string[] => {
  if (!value) return []

  return value
    .split(',')
    .map((v) => v.trim())
    .filter(Boolean)
}
